import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';
import queryString from 'query-string';
import {
    Col,
    Row
} from 'react-bootstrap';

import {
    settingsApproveEmailChange,
} from '../../actions/SettingsActions';

const mapStateToProps = (state) => ({
    ...state.settingsReducer,
    primaryEmail: state.meReducer.me.primaryEmail,
    event: state.eventReducer.event,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    settingsApproveEmailChange
}, dispatch);

// `next` arrives on the query string and is concatenated onto the profile path,
// so it has to resolve to this origin - otherwise it is an open redirect and,
// with a `javascript:` value, script execution.
export const profileUrlFor = (next) => {
    const fallback = window.location.pathname
        .replace(/\/settings\/changeEmailApproval\/?$/, '/settings/profile');
    if (!next) {
        return fallback;
    }
    try {
        const url = new URL(next, window.location.origin);
        if (url.origin !== window.location.origin
            || url.pathname.startsWith('//')
            || url.pathname.startsWith('/\\')) {
            return fallback;
        }
        const cleanedPath = url.pathname.replace(/\/$/, '');
        if (cleanedPath.endsWith('/settings/profile')) {
            return cleanedPath;
        }
        return `${cleanedPath}/settings/profile`;
    } catch (e) {
        return fallback;
    }
};

class MainApproveChangeEmailContainerView extends Component {

    constructor() {
        super();
        this.state = {
            approvingFailed: false
        };
    }

    componentDidMount() {
        const {token, userId, next} = queryString.parse(this.props.location.search);
        const error = () => {
            this.setState({approvingFailed: true});
        };
        const success = () => {
            window.location = profileUrlFor(next);
        };

        this.props.settingsApproveEmailChange({token, userId, error, success});
    }

    render() {
        const {token, userId} = queryString.parse(this.props.location.search);
        const {approvingFailed} = this.state;
        const text = token && userId && !approvingFailed ? 'approving your email request ...' : 'something went wrong';
        const imageName = approvingFailed ? '/images/change_email/reject.png' : '/images/change_email/approve.png';
        return (
            <div className="change-email-container container text-center">
                <Row>
                    <Col xs={12}>
                        <h1><strong>Change Email</strong></h1>
                        <h4 className="margin-top-small">{text}</h4>
                        <img className="change-email-image" src={imageName}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainApproveChangeEmailContainerView);
